import { Component, inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { UserData } from '@shared/components/user-data/user-data';
import { User } from '@shared/interfacres/user';
export interface EditUserData {
  user: User,
  performanceTypes: string[]
}

@Component({
  selector: 'app-edit-genre-dialog',
  templateUrl: 'edit-user-dialog.html',
  styleUrl: './edit-user-dialog.scss',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,

    ReactiveFormsModule,
    UserData,
  ],
})
export class EditUserDialog {
  readonly dialogRef = inject(MatDialogRef<EditUserDialog>);
  readonly data = inject<EditUserData>(MAT_DIALOG_DATA);

  fb = inject(FormBuilder);
  disabled = false;


  form = this.fb.group({
    userData: {
      firstName: this.data.user.firstName || '',
      lastName: this.data.user.lastName || '',
      stageName: this.data.user.stageName || '',

      performanceType: this.data.user.performanceType || [],
      weeklyPerformances: this.data.user.weeklyPerformances || 0,

      website: this.data.user.socialLinks?.website || '',
      instagram: this.data.user.socialLinks?.instagram || '',
      facebook: this.data.user.socialLinks?.facebook || '',
      performanceLocations1: this.data.user.performanceLocations[0] || '',
      performanceLocations2: this.data.user.performanceLocations[1] || '',
      performanceLocations3: this.data.user.performanceLocations[2] || '',

    },
  });

  constructor() {

    console.log('edit-user-dialog.ts => constructor: ', this.data);
    // if (this.data?.name)
    // this.genreName.set(this.data.name);
  }

  save() {
    this.dialogRef.close(this.form.value);

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
